<template>
  <div class="main">
    <h3 style="text-align:center;">健帆-转货平台 sop</h3>
    <h4>转货原则：</h4>
    <div>1、 转货平台仅限内部员工使用；</div>
    <div>2、 每天货车转运时间段为：上午（09:00-12:00）、下午（13:300-16:00），如有用车需求请提前预约。</div>
    <div>预约规则：<br>1)转货用车预约最早可提前1天；<br>2）上午用车（09:00-12:00）须在当天08:40前完成预约；<br>3）下午用车（13:30-16:00）须在当天12:00前完成预约； </div>
    <div>3、 使用部门：仓储物流部、制造一部、制造二部、设备生产部、生产管理部、灌流器总厂-设备部、健力医疗、建航（综合科、生产部）；</div>

    <h4>1. 进入“健帆生物股份”企业微信，选择“内部拼车”</h4>
    <div style="text-align:center;">
      <van-image width="70%" :src="require('../../assets/guide/img1.png')" />
      <br><br>
      <van-image width="70%" :src="require('../../assets/guide/img2.jpg')" />
    </div>
    <h4>2. 发货人流程</h4>
    <div style="text-align:center;">
      <div>1.发货人填写信息</div>
      <van-image width="70%" :src="require('../../assets/transport/1.jpeg')" />
      <van-image width="70%" :src="require('../../assets/transport/12.jpeg')" />
      <div>2.选择收货人</div>
      <van-image width="70%" :src="require('../../assets/transport/2.jpeg')" />
      <div>3.选择送货时间</div>
      <van-image width="70%" :src="require('../../assets/transport/3.jpeg')" />
      <div>4.提交成功后会跳转至订单详情页。在未被转货司机接单前可以取消订单</div>
      <van-image width="70%" :src="require('../../assets/transport/4.jpeg')" />
      <div>5.订单被司机接单后，可在“查看订单”内查看所有订单情况</div>
      <van-image width="70%" :src="require('../../assets/transport/5.jpeg')" />
      <van-image width="70%" :src="require('../../assets/transport/6.jpeg')" />
    </div>
    <h4>3. 司机接单流程</h4>
    <div style="text-align:center;">
      <div>1.在内部拼车应用内，会收到转货订单信息。点击查看详情可进行接单</div>
      <van-image width="70%" :src="require('../../assets/transport/9.jpeg')" />
      <van-image width="70%" :src="require('../../assets/transport/7.jpeg')" />
      <div>2.司机根据实际出发和到达时间，点击“收货出发”和“已送达”按钮，已完成转货任务。到达目的地会有消息自动通知发货人</div>
      <van-image width="70%" :src="require('../../assets/transport/8.jpeg')" />
    </div>
    <h4>4. 收货人流程</h4>
    <div style="text-align:center;">
      <div>1.在内部拼车应用内，会收到收货任务通知。点击查看详情可进行接单</div>
      <div>2.当转货司机点击“已送达”按钮，收货人将收到通知。</div>
      <van-image width="70%" :src="require('../../assets/transport/10.jpeg')" />
      <div>3.点击“确认收货”按钮，完成流程最终状态。</div>
      <van-image width="70%" :src="require('../../assets/transport/11.jpeg')" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    }
  }
</script>

<style lang="less" scoped>
  .main {
    background-color: #ffffff;
    padding: 12px;
    font-size: 14px;
  }
</style>